var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp_flex"},[_c('sui-input-label',{attrs:{"label":_vm.computedLabel,"title":_vm.computedLabel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }